import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import liff from "@line/liff";

import { api } from "../../../@utils/api";
import { UserEventApi } from "@utils/api/analytics/user-event.api";

const isLineLogin = process.env.REACT_APP_LIFF_LOGIN;
const isMockUserLogin = process.env.REACT_APP_EC_LOGIN_MOCK_ENABLE;

function EcLoginGuard() {
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	const initializeLiff = async () => {
		try {
			const LIFF_ID = process.env.REACT_APP_LIFF_ID;
			if (!LIFF_ID) {
				console.error("Missing REACT_APP_LIFF_ID environment variable.");
				return;
			}
			await liff.init({ liffId: LIFF_ID });

			if (!liff.isLoggedIn()) {
				liff.login({ redirectUri: window.location.href });
				return;
			}
			// 檢查 token 是否有效
			await checkToken();
			await checkLogToken();
		} catch (error) {
			console.error("LIFF Initialization failed:", error);
		}
	};

	// 檢查 token 是否有效
	const checkToken = async () => {
		const storedToken = localStorage.getItem("api_token");
		if (storedToken) {
			const isValidToken = await getSelf();
			if (!isValidToken) {
				await refreshAccessToken();
			} else {
				// 登入成功

				setIsAuthenticated(true);
			}
		} else {
			await refreshAccessToken();
		}
	};

	// 重新獲取登入 token 和用戶資料
	const refreshAccessToken = async () => {
		await getLoginApiToken();
		await getSelf();
	};

	const checkLogToken = async () => {
		localStorage.getItem('DATA_TOKEN');
		const dataToken = localStorage.getItem('DATA_TOKEN');
		if (dataToken) {
			const ts = Math.floor(Date.now() / 1000);
			const isValidToken = await UserEventApi.logPage({ path: "liff", ts });
			if (!isValidToken) {
				await getLogLoginApiToken();
			}
		} else {
			await getLogLoginApiToken();
		}
	};

	const getLoginApiToken = async () => {
		let accessToken = "xxxx";
		let profile = {
			userId: "Uf03adaff1021cad8056364f770951123",
		};
		if (isLineLogin === "true") {
			accessToken = liff.getAccessToken() ?? "";
			profile = await liff.getProfile();
		}

		const { userId: line_uid } = profile;
		const loginData = {
			line_uid,
			access_token: accessToken,
			friendship_status: true,
		};
		const res: any = await api.post("/login", loginData);

		const api_token = res.access_token;
		localStorage.setItem("api_token", api_token);
	};

	const getLogLoginApiToken = async () => {
		try {
			let accessToken = 'xxxx';
			let profile = {
				userId: '',
				displayName: '',
			};
			if (isLineLogin === "true") {
				accessToken = liff.getAccessToken() ?? "";
				profile = await liff.getProfile();
			}
			const res = (await UserEventApi.loginEvent({
				line_uid: profile.userId,
				line_name: profile.displayName,
				liff_id: process.env.REACT_APP_LIFF_ID ?? "",
				access_token: accessToken,
			})) as any;
			const data_api_token = res.jwt;
			localStorage.setItem("DATA_TOKEN", data_api_token);
		} catch (error) {
			console.error('Login failed', error);
		}
	};

	const getSelf = async () => {
		try {
			await api.get("/me");
			setIsAuthenticated(true);
			return true;
		} catch (error) {
			console.error("Token validation failed", error);
			setIsAuthenticated(false);
			return false;
		}
	};

	useEffect(() => {
		if (isLineLogin === "true") {
			initializeLiff();
		} else {
			if (isMockUserLogin === "true") {
				setIsAuthenticated(true);
			} else {
				checkToken();
			}
		}
	}, []);

	return isAuthenticated && <Outlet />;
}

export default EcLoginGuard;
